import React from 'react';
import './reportWrapper.scss';
import './ReportTools/reportTools.scss';
import { Droppable } from 'react-beautiful-dnd';
import {
  allDropableID,
  defaultReportType,
  reportItemInterface,
  defaultReportTools,
} from '../../data/defaultSchema';
import { InputTextTools, LineTools, PageBreakTools } from './ReportTools/ReportTools';
import ReportChartItem from './reportChartItem/ReportChartItem';
import { FiFilter } from 'react-icons/fi';
import { CircularProgress } from '@mui/material';
import { mls } from 'lib/multilanguagesupport';
const { reportId } = allDropableID;
interface mainProps {
  stateProps: {
    reports: any[];
    reportFilter: { [key: string]: any };
    setReports: Function;
    isReportPDF?: boolean;
    reportAreaLoading?: boolean;
  };
  setIsFilterVisible?: Function;
  handleReportFilter?: Function;
}

const ReportWrapper = ({
  stateProps,
  setIsFilterVisible = () => {},
  handleReportFilter = () => {},
}: mainProps) => {
  const {
    reports,
    setReports,
    reportFilter,
    isReportPDF = false,
    reportAreaLoading = false,
  } = stateProps;
  if (isReportPDF) {
    return (
      <div className='reportWrapper'>
        <div className='reportWrapperSection'>
          <div className='reportDraggableContainer'>
            {reports.length === 0 && <div className='reportItem noReport'>Add reports</div>}
            {React.Children.toArray(
              reports.map((elm: reportItemInterface, index: number) => (
                <ReportItem
                  targetElem={elm}
                  index={index}
                  reports={reports}
                  setReports={setReports}
                  stateProps={stateProps}
                  isReportPDF={isReportPDF}
                />
              ))
            )}
          </div>
        </div>
      </div>
    );
  }
  const filterNumber = Object.keys(reportFilter ?? {}).length;
  return (
    <div className='reportWrapper'>
      <div className='reportWideFilter'>
        <FiFilter fontSize={'1.4rem'} />
        <div className='titleDiv'>{mls('Report Wide Filter')}:</div>
        <button className='primaryButton ' onClick={() => handleReportFilter(true)}>
          {mls('Open Filter')}
          {filterNumber >= 1 ? (
            <div className='reportWideFilterNumber'>
              {filterNumber >= 100 ? '99+' : filterNumber}
            </div>
          ) : null}
        </button>
      </div>
      <div className='reportWrapperSectionOuter'>
        <div className='reportWrapperSection'>
          {reportAreaLoading ? (
            <div className='reportDraggableContainer'>
              <div className='reportLoading'>
                <CircularProgress />
              </div>
            </div>
          ) : (
            <Droppable droppableId={reportId} key={reportId}>
              {(provided, snapshot) => (
                <div className='reportDraggableContainer' ref={provided.innerRef}>
                  {reports.length === 0 && (
                    <div className='reportItem noReport'>
                      <div className='blankSection'>
                        <div className='blankSectionInner'>
                          {mls('Drag And Drop')}
                          <br /> {mls('Charts From Sheet')}
                          <br /> {mls('Lists')}
                        </div>
                      </div>
                    </div>
                  )}
                  {React.Children.toArray(
                    reports.map((elm: reportItemInterface, index: number) => (
                      <ReportItem
                        targetElem={elm}
                        index={index}
                        reports={reports}
                        setReports={setReports}
                        stateProps={stateProps}
                        isReportPDF={isReportPDF}
                      />
                    ))
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          )}
        </div>
      </div>
    </div>
  );
};
export default ReportWrapper;

export interface reportItemPorps {
  targetElem: reportItemInterface;
  reports: any;
  stateProps: any;
  setReports: Function;
  index: number;
  isReportPDF: boolean;
}

const ReportItem = ({
  targetElem,
  reports,
  setReports,
  stateProps,
  index,
  isReportPDF,
}: reportItemPorps) => {
  const updateReportTools = (updatedData: any) => {
    const duplicateReportArray: any[] = Array.from(reports);
    // remove targetElem
    duplicateReportArray.splice(index, 1);
    // add updated targetElem
    duplicateReportArray.splice(index, 0, updatedData);

    setReports(duplicateReportArray);
  };
  const removeItem = (updatedData: any) => {
    const duplicateReportArray: any[] = Array.from(reports);
    // remove targetElem
    duplicateReportArray.splice(index, 1);
    setReports(duplicateReportArray);
  };
  if (targetElem?.type === defaultReportType.tools) {
    return (
      <ReportToolsItem
        targetElem={targetElem}
        index={index}
        setTargetElem={updateReportTools}
        removeItem={removeItem}
        isReportPDF={isReportPDF}
        stateProps={stateProps}
      />
    );
  }
  if (
    targetElem?.type === defaultReportType.charts ||
    targetElem?.type === defaultReportType.insights
  ) {
    return (
      <ReportChartItem
        stateProps={stateProps}
        targetElem={targetElem}
        index={index}
        setTargetElem={updateReportTools}
        removeItem={removeItem}
        isReportPDF={isReportPDF}
      />
    );
  }
  return <></>;
};
export interface reportToolsPorps {
  targetElem: reportItemInterface;
  setTargetElem: Function;
  removeItem: Function;
  index: number;
  isReportPDF: boolean;
  stateProps: any;
}

const ReportToolsItem = ({
  targetElem,
  setTargetElem,
  removeItem,
  index,
  isReportPDF,
  stateProps,
}: reportToolsPorps) => {
  if (targetElem.reportToolType === defaultReportTools.line.reportToolType) {
    return (
      <LineTools
        targetElem={targetElem}
        index={index}
        setTargetElem={setTargetElem}
        removeItem={removeItem}
        isReportPDF={isReportPDF}
        stateProps={stateProps}
      />
    );
  }
  if (targetElem.reportToolType === defaultReportTools.inputText.reportToolType) {
    return (
      <InputTextTools
        targetElem={targetElem}
        index={index}
        setTargetElem={setTargetElem}
        removeItem={removeItem}
        isReportPDF={isReportPDF}
        stateProps={stateProps}
      />
    );
  }
  if (targetElem.reportToolType === defaultReportTools.pageBreak.reportToolType) {
    return (
      <PageBreakTools
        targetElem={targetElem}
        index={index}
        setTargetElem={setTargetElem}
        removeItem={removeItem}
        isReportPDF={isReportPDF}
        stateProps={stateProps}
      />
    );
  }
  return <></>;
};
